import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchScan } from '../../actions/scan';
import useLocalize from '../../utils/hooks/useLocalize';
import ScanResultsTable from './ScanResultsTable';
import scanResultController from './scanResultController';

function shouldFetchField(field, scanData) {
  const key = field?.id?.toLowerCase();
  return Boolean(field?.id) && !scanData?.[key]?.symbols;
}

const ScanResultsSection = () => {
  const localize = useLocalize();
  const dispatch = useDispatch();

  const selectedScan = useSelector((state) => state.scans.selectedScan || null);
  const scanData = useSelector((state) => state.scans.scanData || {});
  const enabledScanCriteria = useSelector(
    (state) => state.scans.enabledScanCriteria || {}
  );

  const selectedFields = selectedScan?.fields;
  const fields = useMemo(() => selectedFields ?? [], [selectedFields]);

  useEffect(() => {
    if (!fields || fields.length === 0) {
      return;
    }

    fields.forEach((field) => {
      if (shouldFetchField(field, scanData)) {
        dispatch(fetchScan(field.id));
      }
    });
  }, [dispatch, fields, scanData]);

  const isLoading = useMemo(() => {
    if (!fields || fields.length === 0) {
      return false;
    }

    return fields.some((field) => shouldFetchField(field, scanData));
  }, [fields, scanData]);

  // Compute filtered combined results from fetched scan datasets
  const scanResults = useMemo(() => {
    return scanResultController.getCombinedScanResults(
      scanData,
      enabledScanCriteria,
      fields
    );
  }, [fields, scanData, enabledScanCriteria]);

  return (
    <div className="scan-results-section">
      <h3>{localize('scan.result.title') || 'Scan Results'}</h3>
      <ScanResultsTable scanResults={scanResults} isLoading={isLoading} />
    </div>
  );
};

export default ScanResultsSection;
